export default {
    newDesign: true,
    title: "Курс математики | Kodland",
    downtimeUrl: "https://www.kodland.org/ru",
    parameters: {
        landing_id: "CisQMath",
        segment: 37,
        success_page: 'cis_freetc_thankyou',
    },
    startPage: {
        title:
            "Ответьте на несколько вопросов и получите приглашение на БЕСПЛАТНЫЙ курс МАТЕМАТИКИ!",
        subtitle:
            "Начните обучение Вашего ребенка уже сейчас",
        image: {
            url: "/welcome/cis_math_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/cis_math_mob.png",
            style: {
                width: "100%",
            },
        },
        button: " Вперёд 🚀 ",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Спасибо, что доверяете нашей образовательной платформе!",
        subtitle:
            "К сожалению, планшеты и телефоны не подходят для прохождения наших уроков. Будем рады видеть вас на наших занятиях в следующий раз!",
    },
    quizRotateBySteps: {
        1: {
            question: " С какими проблемами в математике вы сталкиваетесь чаще всего?",
            answers: [
                "😕 Cложно понимать текстовые задачи, задачи на логику",
                "😜 Быстро теряет интерес, не хочет заниматься",
                "😞 Есть пробелы по школьной программе",
                "🥱 Боится математики, считает её скучной"
            ],
        },
        2: {
            question: "🎯 Какого результата вы хотите получить от бесплатного курса?",
            answers: [
                "🎓 Ребёнок подтянет математику и закроет пробелы",
                "🤩 Перестанет бояться и полюбит математику",
                "⏳ Будет тратить меньше времени и меньше нервов на домашки",
                "💼 Выберет хорошую профессию и будет больше зарабатывать"
            ],
        },
        3: {
            question: "🎨 Чем увлекается ваш ребёнок?",
            answers: [
                "🎮 Любит играть в игры и проходить челленджи",
                "🏅 Любит спорт и активные игры",
                "📚 Любит читать книги, смотреть научные видео",
                "🖌️ Любит фантазировать, рисовать или что-то мастерить"
            ],
        },
        4: {
            title: "Сколько лет вашему ребёнку?",
            type: "age",
            button: "",
        },
        5: {
            question:
                "У вас есть компьютер или ноутбук? (для обучения не подойдут телефоны, планшеты и устройства без клавиатуры и мыши)",
            answers: [
                "😉 Да",
                {
                    answer: "🤔 Нет",
                    stopAnswer: true,
                },
            ],
        },
        6: {
            title: "Поздравляем! 🎉",
            typeInfo: "congrats",
            subtitle:
                "Чтобы завершить регистрацию на бесплатный онлайн-курс, выберите дату и время для первого урока.",
            button: "Выбрать дату",
        },
        7: {
            title: "Завершите регистрацию",
            type: "one-page-contacts",
            subtitle: "",
            button: "Последний шаг 🔥",
        },
        8: {
            title: "Выберите удобный день для первого урока",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        9: {
            title: "Просмотрите внимательно эту информацию, чтобы завершить регистрацию ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Для урока вам понадобится компьютер или ноутбук со стабильным интернетом. Пожалуйста, будьте рядом с ребёнком во время занятия. Формат занятий индивидуальный.",
            button: "Супер 🔥",
        },
        10: {
            title: "Проверьте электронную почту и WhatsApp перед уроком 📞",
            typeInfo: "whatsapp",
            subtitle:
                "За 24 часа до занятия мы пришлём вам напоминание, а за 2 часа попросим подтвердить своё участие. Очень важно оставаться на связи, чтобы занятие не было отменено.",
            button: "Договорились 👌",
        },
        11: {
            title: "Урок пройдет на нашей платформе 💻",
            typeInfo: "classroom",
            subtitle:
              "Вы получите ссылку и уникальный код через WhatsApp и email. Просто нажмите на ссылку, и вы сразу попадёте на урок. Никаких дополнительных приложений не нужно.",
            button: "Понятно ✅",
        },
    },
};